import $ from 'jquery';

$(() => {
	//Take it away
})